"use client";

import { useEffect, useState } from "react";
import GetInTouch from "@/components/modals/get-in-touch";

export default function BlogContactTrigger() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const check = () => {
      if (window.location.hash === "#contact") {
        setOpen(true);
        history.replaceState(null, "", window.location.pathname);
      }
    };
    check();
    window.addEventListener("hashchange", check);
    return () => window.removeEventListener("hashchange", check);
  }, []);

  return <GetInTouch open={open} onOpenChange={setOpen} />;
}
